import { Group, Flex, Stack, Badge, Text, Button } from '@mantine/core';
import { ReactNode } from 'react';

type TableTitleBarProps = {
  title?: string;
  subtitle?: string;
  titleIcon?: ReactNode;
  onTitleClick?: () => void;
  totalRecords?: number;
  showCount?: boolean;
  primaryButton?: {
    label: string;
    variant?: 'default' | 'primary';
    onClick: () => void;
  };
};

export default function TableTitleBar({
  title,
  subtitle,
  titleIcon,
  onTitleClick,
  totalRecords,
  primaryButton,
  showCount = false,
}: TableTitleBarProps) {
  if (!title) return null;

  return (
    <Group
      px="lg"
      py="sm"
      style={{
        borderBottom: 'var(--solid-border)',
      }}
      display="flex"
      justify="space-between"
    >
      <Flex
        style={onTitleClick ? { cursor: 'pointer' } : {}}
        onClick={() => onTitleClick?.()}
        gap="xs"
        align="center"
      >
        <Stack gap="xs">
          <Group gap="xs">
            {titleIcon}
            {title && (
              <Text size="lg" fw={600} c="gray.10">
                {title}
              </Text>
            )}
            {totalRecords != null && totalRecords > 0 && showCount && (
              <Badge
                ml="xs"
                size="md"
                variant="light"
                color="orange"
                style={{
                  border: '1px solid orange',
                }}
              >
                {totalRecords}
              </Badge>
            )}
          </Group>
          {subtitle && (
            <Text size="sm" c="gray.7">
              {subtitle}
            </Text>
          )}
        </Stack>
      </Flex>
      {primaryButton && (
        <Button onClick={primaryButton?.onClick} variant={primaryButton.variant}>
          {primaryButton?.label}
        </Button>
      )}
    </Group>
  );
}
